import { Link } from "react-router-dom";
import classNames from "../../../utils/classNames";
import { ReactNode } from "react";

interface LinkButtonProps {
  label?: string;
  to: string;
  classes?: string;
  disabled?: boolean;
  children?: ReactNode;
}

export const LinkButton = ({ label = "", to, classes = "", disabled = false, children = <p></p> }: LinkButtonProps) => {
  return (
    <Link
      to={to}
      className={classNames(
        label.length > 0
          ? "px-3 py-2 shadow-sm bg-primary-600 hover:bg-primary-700 disabled:bg-gray-500 disabled:hover:bg-gray-500 text-white"
          : "text-primary-600 hover:text-primary-700 disabled:text-gray-500 disabled:hover:text-gray-500",
        "rounded-md border border-transparent text-sm font-medium leading-4",
        classes,
        disabled ? "pointer-events-none opacity-50" : ""
      )}
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
    >
      {label.length > 0 ? label : children}
    </Link>
  );
}; 